module.exports = __webpack_public_path__ + "static/media/1.0d74a94b.png";